class Result {
  constructor(steps) {
    this.steps = steps;
    
    this.front = null;
    this.back = null;
    this.face = null;
    this.final = null;
    
    this.ready = false;
    this.finalCanBeFull = false;
  }

  setStepResult(step, result) {
    this[step] = result;
    
    this.ready = (this.final !== null) &&
                 (this.steps.filter(name => this[name] !== null).length === this.steps.length);

    this.finalCanBeFull = this.front === Result.Passed || 
                          this.back === Result.Passed || 
                          this.face === Result.Passed;
  }
}

Result.Passed = 'full';
Result.Failed = 'fail';

export { Result }
